var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5002 4.66602C8.45007 4.66602 5.16683 7.94926 5.16683 11.9993C5.16683 16.0494 8.45007 19.3327 12.5002 19.3327C16.5503 19.3327 19.8335 16.0494 19.8335 11.9993C19.8335 7.94926 16.5503 4.66602 12.5002 4.66602ZM3.16683 11.9993C3.16683 6.84469 7.3455 2.66602 12.5002 2.66602C17.6548 2.66602 21.8335 6.84469 21.8335 11.9993C21.8335 17.154 17.6548 21.3327 12.5002 21.3327C7.3455 21.3327 3.16683 17.154 3.16683 11.9993Z",
    fill: "#008638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.29395C11.5 7.74167 11.9477 7.29395 12.5 7.29395H12.5083C13.0606 7.29395 13.5083 7.74167 13.5083 8.29395C13.5083 8.84624 13.0606 9.29395 12.5083 9.29395H12.5C11.9477 9.29395 11.5 8.84624 11.5 8.29395ZM12.5 10.2371C13.0523 10.2371 13.5 10.6848 13.5 11.2371V15.6325C13.5 16.1848 13.0523 16.6325 12.5 16.6325C11.9477 16.6325 11.5 16.1848 11.5 15.6325V11.2371C11.5 10.6848 11.9477 10.2371 12.5 10.2371Z",
    fill: "#008638"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlertIcon);
export default __webpack_public_path__ + "static/media/SuccessAlertIcon.177af30e67057b04f2a20cd3bd3efb46.svg";
export { ForwardRef as ReactComponent };